<script>
  export default {
    name: 'AccountSwitcher',
  };
</script>

<template>
  <div class="account-switcher">
    <div class="icon">
      <img
        alt=""
        src="@/assets/imgs/icons/topbar/account-logo.svg"
      />
    </div>
    <div class="content">
      <div class="title">Currently Viewing</div>
      <div class="account-name">Bevatel Account</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .account-switcher {
    cursor: pointer;
    height: 50px;
    max-width: fit-content;
    border-radius: 12px;
    border: 1px solid var(--gray100);
    padding: 8px;
    display: flex;
    gap: 8px;
    .icon {
      width: 32px;
    }
    .content {
      .title {
        font-size: 12px;
        color: var(--gray400);
        line-height: 12px;
        font-weight: 400;
      }
      .account-name {
        line-height: normal;
      }
    }
  }
</style>
